import config from "@/config";
import { constants } from "@/constants";
import { useTranslation } from "react-i18next";
import { HiComputerDesktop } from "react-icons/hi2";

import Logo from "@/components/atoms/Logo";

const MobileRestrictionPage = () => {
  const { t } = useTranslation();

  return (
    <div className="flex h-screen w-screen flex-col items-center justify-between bg-secondary">
      <div className="flex flex-grow flex-col items-center justify-center">
        <div className="flex size-14 items-center justify-center rounded-full bg-brand-primary-subtle">
          <HiComputerDesktop className="size-7 text-fg-brand-primary" />
        </div>
        <div className="my-7 px-[12vw] text-center">
          <h1 className="text-xl font-semibold text-primary">{t("mobileRestriction.title")}</h1>
          <p className="mt-4 text-sm text-tertiary">{t("mobileRestriction.message", { name: config.APP_NAME })}</p>
        </div>
      </div>

      <div className="mb-4 flex flex-col items-center gap-2">
        <Logo className="size-7" />
        <a
          className={"text-xs text-quaternary hover:text-quaternary-hover active:text-quaternary-pressed"}
          href={`mailto:${constants.supportMail}`}
        >
          {constants.supportMail}
        </a>
      </div>
    </div>
  );
};

export default MobileRestrictionPage;
